module.exports = {"name":"Zoznam súborov bez dátumu","icon":"<i class='material-icons'>attach_file</i>","widget":[{"type":"file-list-without-date","initData":{"files":[]}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/file-list-without-date/file-list-without-date.json
// module id = 332
// module chunks = 0